import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import SimpleResourceItems from "./SimpleResourceItems";
import NoResourceMessage from "./NoResourceMessage";

function VideoResouces(props) {
    const [videoResourceItems, setVideoResourceItems] = useState([]);
    const [dataPulled, setDataPulled] = useState(false);
    const handleResourceData = async () => {
      const response = await makeGetRequest(
        urls.resources + "?active=True&resource_type=3",
        "",
        true
      );
      setVideoResourceItems(response.data);
      setDataPulled(true);
    };
  
    useEffect(() => {
      handleResourceData();
    }, []);

  return (
            videoResourceItems.length === 0 & dataPulled === true ? <NoResourceMessage /> : <SimpleResourceItems items={videoResourceItems} />
             
  )
}

export default VideoResouces